import { useQuery } from "react-query"
import { showVehicleRecordDataSources } from "../showVehicleRecordsDataSources"

export const VehicleRecordDataSourcesKey = "VehicleRecordDataSources"

export const useVehicleRecordDataSources = (vehicleId: string) => {
    const {
        data: vehicleRecordDataSources,
        isLoading,
        isRefetching,
    } = useQuery({
        queryKey: [VehicleRecordDataSourcesKey, vehicleId],
        queryFn: ({ queryKey: [, vehicleIdFromKey] }) => showVehicleRecordDataSources(vehicleIdFromKey),
        staleTime: 5000 * 60,
    })

    return {
        vehicleRecordDataSources,
        isLoading: isLoading || isRefetching,
    }
}
